<template>
    <div>
        <div v-if="historial">
        
        <div v-if="historial.statusDepto == 'Inactivo'" class="inactive-class" 
        style="display:flex;color:#005cc3;margin-left:4rem;margin-top:2.2rem;margin-bottom:3rem;">
            <img src="../assets/error-file.png" style="width:4.4rem;height:4.5rem;margin-top:.7rem;">
            <h5 style="margin-left:1.5rem;margin-top:2rem;">Este departamento no se encuentra<br>
            activo en la base de datos.</h5>  
        </div>

         <b-row class="px-5 pt-3 pb-3" id="pilas-form-admin">  
            
            <b-col  v-if="!(this.depName == 'Mantenimiento' ||this.depName == 'Vigueta'  ||this.depName == 'Insulpanel' || this.depName == 'Bono Garantía' ) && prod" class="bg-white p-4 col-6 adminPila pila-prod  mb-4" >
                <b-row class="produccion">
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #005cc3;"></div></b-col>
                    <b-col class="pl-3 pr-5 colprod">
                        <p class="stylingTitle">Producción </p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Lunes</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Martes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5" style="color: #838383;">Miércoles </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Jueves </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Viernes </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Sábado</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Domingo</p></strong></th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1 " style="color: #fd832d;">
                                                     <template v-if="historial.prod.lunes > 0"> {{historial.prod.lunes | rand}}</template>
                                                    <template v-else>{{historial.prod.lunes }}</template>    
                                                </li>
                                            </ul>
                                            
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">                                            
                                                     <template v-if="historial.prod.martes > 0"> {{historial.prod.martes | rand}}</template>
                                                    <template v-else>{{historial.prod.martes }}</template>                                         
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="historial.prod.miercoles > 0"> {{historial.prod.miercoles | rand}}</template>
                                                    <template v-else>  {{historial.prod.miercoles}}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                  <template v-if="historial.prod.jueves > 0"> {{historial.prod.jueves | rand}}</template>
                                                    <template v-else> {{historial.prod.jueves }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                   <template v-if="historial.prod.viernes > 0"> {{historial.prod.viernes | rand}}</template>
                                                    <template v-else>  {{historial.prod.viernes }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="historial.prod.sabado > 0"> {{historial.prod.sabado | rand}}</template>
                                                    <template v-else>  {{historial.prod.sabado }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                         <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li  class="stylingSmall5 mb-1" style="color: #fd832d;">
                                                    <template v-if="historial.prod.domingo > 0"> {{historial.prod.domingo | rand}}</template>
                                                    <template v-else>  {{historial.prod.domingo }}</template>    
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                    </b-col>
                </b-row>                       
            </b-col>  
            
            <b-col  v-else-if="this.depName == 'Mantenimiento'" class="bg-white p-4 col-6 adminPila pila-prod  mb-4" >
            
                <b-row class="produccion">
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #005cc3;"></div></b-col>
                    <b-col class="pl-3 pr-5 colprod">
                        <p class="stylingTitle">Montos recibidos por área</p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Area</p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall5 " style="color: #838383;">Monto </p></strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                 <li v-for="item in historial.areas" :key="item.id" class="stylingSmall5 mb-1" style="color: #005cc3;">                                            
                                                    <template >{{item}}</template>                                               
                                                 </li>
                                            </ul>
                                            
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul class="pl-1" style="list-style-type: none;">
                                                <li v-for="item in historial.montos_recibidos_area" :key="item.id" class="stylingSmall5 mb-1" style="color: #fd832d;">                                            
                                                    <template v-if="item && item > 0">{{item | rand }}</template>
                                                    <template v-else>{{item}}</template>                                                    
                                                </li>
                                            </ul>
                                        </td>
                                      
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                       
                        <div v-if="city =='Juárez'" class="stylingSmall6" >
                            <p> <span style="color:#838383;">Corte Construcción:</span > <span style="color:#bcbcbc; "> Promedio <span style="color: #838383;"> &#10142;</span> Electrolux, Corte, Placa, Aligerante. </span> </p>
                            <p> <span style="color: #838383;">Corte Maquila:</span>  <span style="color: #bcbcbc;">Promedio <span style="color: #838383;"> &#10142;</span> Aos Mith, Commscope, Mcs Frame.</span> </p>
                        </div>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.semana}}</p>
                        </div> 
                    </b-col>
                      
                </b-row>   
                                 
            </b-col> 
             
            <b-col v-else-if="depName == 'Bono Garantía'" class="bg-white p-4 col-12 mb-4 adminPila2" >   
                
                <b-row>
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales </p>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">Monto Base: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.pago_base}}</p>
                        </div>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.semana}}</p>
                        </div>
                    </b-col>                            
                </b-row>  
                                                                  
            </b-col>  
            
            <b-col  class="bg-white p-4 col-12 mb-4 adminPila2"   v-else-if="depName == 'Vigueta'">
              
                     <b-row>
                        
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales </p>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">Monto base diario: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.pago_dia}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">Dias sucios: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.dias_sucios}}</p>
                        </div>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.semana}}</p>
                        </div>
                    </b-col>                            
                </b-row>  
                
                  
            </b-col >

            
                 
           
               <b-col class="bg-white p-4 col-12 mb-4 adminPila2"   v-else-if="depName == 'Insulpanel' && city=='Guadalajara'">   
                <b-row>
                        
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales </p>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">Monto base: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.pago_base}}</p>
                        </div>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.semana}}</p>
                        </div>
                    </b-col>                            
                </b-row>    

                        
                                                                    
               </b-col>        
           
            
                 
             
               <b-col class="bg-white p-4 col-12 mb-4 adminPila" v-else-if="(depName == 'Insulpanel' && city=='Hermosillo')|| (depName == 'Insulpanel' && city=='Mexicali')" >   
            <b-row>
  
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2">Montos base por nivel de carrera  </p>
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">NI: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.pago_base.NI}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">N1: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.pago_base.N1}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">N2: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.pago_base.N2}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">N3: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.pago_base.N3}}</p>
                        </div>
                        <div class="row ml-1" v-if="depName == 'Insulpanel' && city=='Hermosillo'">
                            <strong><p class="stylingSmall5 mr-2" style="color: #838383;">N4: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.pago_base.N4}}</p>
                        </div>
                       
                        <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.semana}}</p>
                        </div>

                         
                    </b-col>                            
                </b-row>    
                            
                                                                    
               </b-col>        
          
          
             <b-col v-if="!(this.depName == 'Mantenimiento' ||this.depName == 'Vigueta'  ||this.depName == 'Insulpanel' || this.depName == 'Bono Garantía' )" class="bg-white p-4 col-12 mb-4 adminPila" >   
                <b-row>
                   
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #9d3eff;"></div></b-col>
                    <b-col class="pl-3 pr-5">
                        <p class="stylingTitle pb-2"> Datos generales  </p>
                       <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Base 0: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.base0}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Dias sucios: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.dias_sucios}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">$ Extra: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.extram3}}</p>
                        </div>
                         <div class="row ml-1">
                            <strong><p class="stylingSmall5  mr-2" style="color: #838383;">Semana: </p></strong>
                            <p class="stylingSmall5 mb-1" style="color: #fd832d;"> {{historial.semana}}</p>
                        </div>

                    </b-col>                            
                </b-row>                                                     
            </b-col>
            
            <b-col class="bg-white p-4 col-6 adminPila" >
               
                <b-row>
                    <b-col cols="1" class="pr-0 pt-1"><div class="square1" style="background-color: #00c290;"></div></b-col>
                    <b-col class="pl-3">
                        <p class="stylingTitle">Colaboradores </p>
                        <b-row>

                            <table class="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Nombre: </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Bono al día: </p></strong></th>
                                        <th class="pb-0 pt-0" scope="col"><strong><p class="stylingSmall" style="color: #838383;">Asistencia: </p></strong></th>
                                    </tr>
                                </thead>
                                <tbody>
                                   <tr>
                                        <td class="pb-0 pt-0">
                                            <ul>
                                                <li v-for="item in historial.equipo" :key="item.id" class="stylingSmall mb-1">
                                                    <template>{{item.nombre | cap }} </template>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul style="list-style-type: none;">
                                                <li v-for="item in historial.equipo" :key="item.id" class="stylingSmall mb-1" style="color: #fd832d;">                                            
                                                    <template v-if="item && item.bono > 0">$ {{item.bono | rand }}</template>
                                                    <template v-else>$ 0</template>                                                    
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="pb-0 pt-0">
                                            <ul style="list-style-type: none;">
                                                <li v-for="item in historial.equipo" :key="item.id" class="stylingSmall mb-1" style="color: #fd832d;">
                                                    {{item.asis}}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>

                        </b-row>
                    </b-col>
                </b-row>                       
            </b-col>
            
        </b-row>      
   
        </div>
        <div v-else>
             <div  class="message-lastweek-prox">
                <p class="message-lastweek-icon">&#9881; <span class="littleicon">&#9881;</span> </p>
                <p class="message-lastweek">Próximamente...</p>
            </div>
        </div>
    </div>
</template>



<script>

export default {
    name: 'HistorialSemanas',
    props: {
        
        historial:{
            required:true
        }
    },  
    data() {
        return {
            semana:'',
            prod:{
            lunes: 0,
            martes: 0,
            miercoles: 0,
            jueves: 0,
            viernes: 0,
            sabado: 0,
            domingo:0
             }
        }
    },
    computed: {
      
        depName() {
            return this.$store.getters["admin/getDep"];
        },
        city(){
            return this.$store.getters['admin/getName'];
        },
        
    },
    
    methods: {
        
         smn: function (value){
            if (!value) return '';
             value = value.toString();
             let splitStr = value.split(' a ');

             return splitStr[1]
        }
    },
    filters:{
        rand: (value) => {
            if (!value) return '';
            if (typeof value === 'number') {
                return value.toFixed(2);
            }
            return value;
        },
        stringify: (value) => {
            if(!value) return '0';
            if (typeof value == 'number'){
                return value.toString();
            }
        },
        cap: (value) => {
            if (!value) return '';
            value = value.toString();
            let splitStr = value.toLowerCase().split(' ');
            let len = splitStr.length
            let i; 
            for (i = 0; i < len; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            let nameCap = splitStr.join(' '); 
            return nameCap;
        }
    }
}
</script>
<style scoped>
.active {
     background-color: #fe9136 !important;
    border-color: #fe9136 !important;
}

.square1{
    height: 10.5px;
    width: 10.5px;
    margin-top: 3.4px;
}
.icon{
    max-width: 1rem;
    cursor: pointer;
}
input#inputB0,
input#inputDS,
input#inputE,
input#inputM{
    font-family: 'FuturaPTMedium';
    border-color: #d2d6dd;
    min-width: 80px;
    border-radius: 7px;
    color: #fd832d
}
label{
    font-family: 'FuturaPTMedium';
    color: #838383 !important;
    font-size: 95% !important;
    font-weight: 100 !important;
}
.stylingTitle{
    font-family: 'FuturaPTMedium';
    color: #bcbcbc;
    font-size: 1rem;
}
.labelB0{
    margin-right: 6rem;
}
.labelDS{
    margin-right: 4.5rem;
}
::placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
:-ms-input-placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
::-ms-input-placeholder {
  color: #fd832d;
  font-size: 14px;
  opacity: .8;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.adminPila{
    min-height: 15rem;
    min-width: 100%;
}

.adminPila2{
    min-height: 10rem;
    min-width: 100%;
}
ul{
    padding: 0;
    padding-left: 1rem;
    font-size: small;
}
.blue {
    background-color: #4d78e7;
    border-radius: 20px;
    font-size: 14px;
    font-family: 'FuturaPTMedium';
    padding: 11px 0px;
    color: white;
}
.blue:hover{
    background-color: #3b63c9;
}
.saved{
    background-color: white;
    border: 1px solid #3b63c9;
    color: #3b63c9;
    border-radius: 20px;
    font-size: 14px;
    font-family: 'FuturaPTMedium';
    padding: 11px 0px;
}
li >>> a {
    color: #838383;
}
@media (max-width: 420px) { 
    div.inactive-class img{
        margin-left: -2rem;
    }
    div.inactive-class h5{
        margin-right:2rem;
        font-size:.9rem;
    }
}
@media (max-width: 527px) { 
    div.inactive-class h5{
        margin-right:2rem;
    }
}
</style>